import React from 'react'
import type { ConnectorProps as ARExperienceProps } from '../../connectors/ARExperience'
import ARExperienceConnector from '../../connectors/ARExperience'
import { ViewInRoomARIcon, Action, VIRActionStatic } from '../styles/gallery'



type Props = ARExperienceProps

const Mobile2 = (props: Props) => {
  const { openARExperience } = props

  return (
    <VIRActionStatic>
      <Action
        onClick={() => {
          openARExperience()
        }}
        data-type='view-in-room-AR'
        title='View this art on your wall'
      >
        <ViewInRoomARIcon />
        <p className='defaultTypographyCtaMedium'>View In My Room</p>
      </Action>
    </VIRActionStatic>
  )
}

export default ARExperienceConnector(Mobile2)